import { createFileRoute } from "@tanstack/react-router";

import { SupportListContainer } from "@/features/app-support/containers/support-list-container";

export const Route = createFileRoute("/app/settings/user/support/")({
  component: SupportListContainer,
});
